module.exports = __webpack_public_path__ + "static/media/CTLI_2-391w.333effb9.png";